var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs list-unstyled"},_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return _c('li',{key:'breadcrumb' + index,staticClass:"breadcrumbs__item"},[_c('Link',{staticClass:"breadcrumbs__link",attrs:{"link":breadcrumb.link}},[_vm._v(_vm._s(breadcrumb.text))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }